const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'basic',
      column: 1,
      type: 'component',
      config: { columns: 2 },
    },
    {
      name: 'code',
      label: 'Rodzaj dokumentu',
      column: 1,
      type: 'enum',
      enumType: 'enums/legalDocumentCode',
      component: 'basic',
      mandatory: true
    },
    {
      name: 'title',
      label: 'Nazwa wersji',
      column: 2,
      component: 'basic',
      mandatory: true
    },

    {
      name: 'version',
      label: 'Wersja',
      column: 1,
      onlyForReadOnly: true,
      component: 'basic',
    },
    {
      name: 'creationDate',
      label: 'Data utworzenia',
      column: 2,
      onlyForReadOnly: true,
      component: 'basic',
    },
    {
      name: 'file',
      label: 'Plik',
      column: 1,
      type: 'file',
      single: true,
      fileFormats: ["PDF"],
      rows: 40,
      mandatory: true
    },
  ],
};

export default fields;
